import type { ApiProvider } from '../../core/api/api.types';

/**
 * Order the assignment drawer's provider list.
 *
 * The backend has already scoped the list to the order's category and city, so
 * there is no filtering to do here beyond the operator's free-text search. The
 * single recommended provider is pinned to the top; everyone else is
 * alphabetical. No other ranking is applied — all providers work on equal terms.
 */
export function sortProvidersForDrawer(
  providers: ApiProvider[],
  recommendedId: string | null,
  query: string,
): ApiProvider[] {
  const q = query.trim().toLowerCase();

  // Once the input holds a provider's exact name the operator has already
  // chosen; keep offering the alternatives instead of collapsing to one row.
  const exactMatch = q ? providers.some((p) => p.name.toLowerCase() === q) : false;
  const matched =
    !q || exactMatch ? [...providers] : providers.filter((p) => p.name.toLowerCase().includes(q));

  return matched.sort((a, b) => {
    if (a.id === recommendedId) return -1;
    if (b.id === recommendedId) return 1;
    return a.name.localeCompare(b.name);
  });
}
